import React, { Component } from 'react';
import { Modal, Button, Spin } from 'antd';
import TableC from '../../basicElement/TableC';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';

export default class Operation extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        record: {},
        pagination: {
            pageSize: 5,
            current: 1,
        },
    }

    loadData = () => {
        const { record:{ contractBackRecordId }, pagination:{ current, pageSize } } = this.state;
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.queryContractBackActualPaymentTermLog, {
            offset: current,
            limit: pageSize,
            contractBackRecordId
        }).then(res => {
            const { contractBackActualPaymentTermOperateLogs } = res;
            this.setState({
                data:contractBackActualPaymentTermOperateLogs,
                loading: false,
            });
        }).catch(err => {
            console.error(err);
            this.setState({ loading: false });
        });
    }

    show = (record) => {
        this.setState({
            record,
            visible: true,
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    getColumns = () => {
        const columns = [{
            title: '操作时间',
            dataIndex: 'createTime',
            key: 'createTime',
            width: 80,
        }, {
            title: '操作人',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 120,
            render: (text, record) => {
                const { employeeCode } = record;
                return `${text}[${employeeCode}]`
            }
        }, {
            title: '操作内容',
            dataIndex: 'operateType',
            key: 'operateType',
            width: 120,
            render: text => {
                let el = '';
                switch (text) {
                    case 'APPROVAL':
                        el = '审核合同约定账期'
                        break;
                    case 'SETTING':
                        el = '配置合同约定账期'
                        break;
                }
                return el
            }
        }, {
            title: '操作结果',
            dataIndex: 'operateResult',
            key: 'operateResult',
            width: 120,
            render: text => {
                let el = '';
                switch (text) {
                    case 'PENDING_APPROVAL':
                        el = '待审核'
                        break;
                    case 'DISAGREE_APPROVAL':
                        el = '审核不通过'
                        break;
                    case 'AGREE_APPROVAL':
                        el = '审核通过'
                        break;
                }
                return el
            }
        }, {
            title: '拒绝/不通过原因',
            dataIndex: 'comment',
            key: 'comment',
            width: 120,
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        });
    }
    
    render() {
        const { visible, record, loading, data, pagination } = this.state;
        const { remark, jdecode } = record;
        return (
            <Modal
                title="操作日志"
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width={700}
                bodyStyle={{ maxHeight: 500 }}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div>
                        <p style={{ marginBottom: 10 }}>
                            <span style={{ paddingRight: 16 }}>JDE项目号:</span>
                            { jdecode }
                        </p>
                        <p style={{ marginBottom: 10 }}>
                            <span style={{ paddingRight: 16 }}>发票号:</span>
                            { remark }
                        </p>
                        <TableC
                            data={data}
                            scrollY={300}
                            onChange={this.handleTableChange}
                            columns={this.getColumns()}
                            pagination={pagination}
                        />
                    </div>
                </Spin>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/returnedMoney/Operation.js